<template>
  <div class="agent-detail-popover" id="agentDetailPopover" v-show="open" :style="popoverStyle">
    <!-- 头部 -->
    <div class="adp-head">
      <div class="adp-head-copy">
        <div class="adp-title">定时任务</div>
        <div class="adp-sub">显示任务标题，支持导航跳转，点击后全屏查看</div>
      </div>
      <button class="adp-close" type="button" @click="close">×</button>
    </div>
    <!-- 加载中 -->
    <div v-if="loading" class="adp-loading">
      <div class="adp-spinner"></div>
      <span>加载中…</span>
    </div>
    <!-- 任务列表 -->
    <div v-else class="adp-list">
      <button
        v-for="task in tasks"
        :key="task.id"
        class="adp-task-item"
        type="button"
        @click="openTask(task)"
      >
        <div class="adp-task-title">{{ task.title }}</div>
        <div class="adp-task-meta">
          <span v-if="task.lastRun" class="adp-task-freq">{{ task.lastRun }}</span>
          <span v-if="task.totalRuns != null" class="adp-task-runs">已执行 {{ task.totalRuns }} 次</span>
          <span class="adp-task-status" :class="statusClass(task.status)">{{ task.status }}</span>
        </div>
      </button>
      <div v-if="!tasks.length" class="adp-empty">暂无定时任务</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'AgentDetailPopover',
  computed: {
    ...mapState(['agentDetailPopover', 'currentSessionKey', 'sessionItems']),
    ...mapGetters(['currentAgentTasks']),
    open() { return this.agentDetailPopover.open },
    loading() { return this.agentDetailPopover.loading || false },
    tasks() { return this.currentAgentTasks },
    popoverStyle() {
      const x = this.agentDetailPopover.x
      const y = this.agentDetailPopover.y
      if (x == null || y == null) return {}
      return { position: 'fixed', left: x + 'px', top: y + 'px' }
    }
  },
  methods: {
    ...mapActions(['closeAgentDetailPopover', 'openAgentInsightModal', 'openAgentTaskPreview']),
    close() { this.closeAgentDetailPopover() },
    openTask(task) {
      this.closeAgentDetailPopover()
      this.openAgentTaskPreview(task.id)
    },
    statusClass(status) {
      if (status === '进行中' || status === '运行中') return 'status-running'
      if (status === '已完成') return 'status-done'
      if (status === '待执行' || status === '待开始') return 'status-pending'
      if (status === '异常') return 'status-error'
      if (status === '已停用') return 'status-disabled'
      return ''
    },
    handleGlobalClick(e) {
      if (this.open && !this.$el.contains(e.target)) {
        this.closeAgentDetailPopover()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document.addEventListener('click', this.handleGlobalClick)
      }, 0)
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>

<style scoped>
.adp-loading {
  padding: 32px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: #6F8398;
  font-size: 13px;
  font-weight: 700;
}
.adp-spinner {
  width: 22px;
  height: 22px;
  border: 3px solid rgba(91,141,239,.15);
  border-top-color: #5B8DEF;
  border-radius: 50%;
  animation: adp-spin .7s linear infinite;
}
@keyframes adp-spin {
  to { transform: rotate(360deg); }
}
.adp-task-result {
  font-size: 11px;
  line-height: 1.6;
  color: #94A4B5;
  margin-top: 4px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.adp-task-runs {
  font-size: 11px;
  color: #6F8398;
}
.adp-task-status.status-error {
  background: rgba(239,68,68,.08);
  color: #dc2626;
}
.adp-task-status.status-disabled {
  background: rgba(148,164,181,.10);
  color: #6F8398;
}
</style>
